import React from 'react';

const MetricCard = ({ title, value, label, icon: Icon }) => (
  <div className="bg-white p-4 rounded-lg shadow-md w-full max-w-full">
    <div className="flex items-center mb-2">
      {Icon && <Icon className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0" />}
      <h3 className="text-[#4C4D5E] text-base font-semibold truncate">
        {title}
      </h3>
    </div>
    <p className="text-[#0C60F2] text-2xl font-semibold mt-1">
      {value}
    </p>
    <p className="text-[#4C4D5E] text-xs mt-1 truncate">
      {label}
    </p>
  </div>
);

export default MetricCard;



// import React from 'react';

// const MetricCard = ({ title, value, label }) => (
//   <div className="bg-white p-6 rounded-lg shadow-md max-w-full">
//     <h3 className="text-[#4C4D5E] mb-4 text-lg font-semibold">
//       {title}
//     </h3>
//     <p className="text-[#0C60F2] text-3xl font-semibold">
//       {value}
//     </p>
//     <p className="text-[#4C4D5E] text-sm">
//       {label}
//     </p>
//   </div>
// );

// export default MetricCard;